<div class="date-range">
  <h2 class="date-range__title">Custom date range</h2>

  <div class="date-range__fields">
    <div class="date-range__field">
      <span class="date-range__field-label">Start date</span>
      <button
        type="button"
        class="date-range__field-value pendo-date-range-start"
        [class.date-range__field-value--empty]="!range.start"
        (click)="resetSelection()"
      >
        {{ startLabel }}
      </button>
    </div>

    <mat-icon class="date-range__arrow">arrow_forward</mat-icon>

    <div class="date-range__field">
      <span class="date-range__field-label">End date</span>
      <div
        class="date-range__field-value"
        [class.date-range__field-value--empty]="!range.end"
      >
        {{ endLabel }}
      </div>
    </div>
  </div>

  <div class="date-range__calendars">
    <mat-calendar
      class="date-range__calendar"
      [startAt]="leftStartAt"
      [selected]="range"
      [minDate]="minDate"
      [maxDate]="maxDate"
      (selectedChange)="onDateSelected($event)"
    ></mat-calendar>
    <mat-calendar
      class="date-range__calendar"
      [startAt]="rightStartAt"
      [selected]="range"
      [minDate]="minDate"
      [maxDate]="maxDate"
      (selectedChange)="onDateSelected($event)"
    ></mat-calendar>
  </div>

  <div class="date-range__footer">
    <span class="date-range__hint" *ngIf="invalidReason">{{
      invalidReason
    }}</span>
    <button
      type="button"
      class="date-range__apply pendo-date-range-apply"
      [disabled]="!canApply"
      (click)="apply()"
    >
      Apply
    </button>
  </div>
</div>
